<template>
  <settlement-widget v-model="model" @search="search = $event">

  <v-autocomplete
    :loading="loading"
    v-model="model"
    :search-input.sync="search"
    :items="items"
    item-value="code"
    item-text="text"
    return-object
    :error-messages="errorMessages"
    flat
    hide-no-data
    no-filter
    :label="label"
    :rules="rules"
    :hint="hint"
    persistent-hint
    @input="changed"
    @dblclick.native="!isNonBg && querySelections('?')"
    ref="suggester_settlement"

    :menu-props="{ closeOnClick: isNonBg }"
    :readonly="isNonBg"
  >
    <template v-slot:prepend v-if="!isNonBg">
      <v-menu offset-y allow-overflow max-height="400px">
        <template #activator="{ on: menu }">
          <v-tooltip bottom>
            <template #activator="{ on: tooltip }">
              <!-- <v-avatar v-on="{ ...tooltip, ...menu }" color="blue-grey lighten-1" size="24">
                <span class="white--text body-1">{{ value.country.code }}</span>
              </v-avatar> -->
              <v-icon v-on="{ ...tooltip, ...menu }">public</v-icon>
            </template>
            <span>{{ $t('Change country') }}</span>
          </v-tooltip>
        </template>
        <v-list subheader>
          <template v-for="item in countriesVisible">
            <v-list-tile :key="item.id" @click="onCountry(item)">
              <v-list-tile-avatar size="36" :color="item.id == 1 ? 'green lighten-3' : 'blue lighten-3'" class="white--text">
                {{ item.code }}
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="d-flex" style="align-items: baseline">
                  {{ item.text }}
                  <v-icon v-if="!item.is_allowed_orders" small color="grey"
                    class="ml-3" style="justify-content: flex-end"
                    :title="$t('WARNING.COUNTRY.ORDERS_DISALLOWED')"
                  >fa-calculator</v-icon>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>
    </template>
    <template v-slot:append-outer v-if="model && model.settlement && model.settlement.client_message">
      <settlement-client-message v-model="model.settlement"></settlement-client-message>
    </template>
  </v-autocomplete>

  </settlement-widget>
</template>

<script>
import { debounce } from "lodash";
import { suggest } from "../resources";
import { postProcessMessageDOM } from "./util.js";
import SettlementWidget from "@/components/SettlementWidget.vue";
import SettlementClientMessage from "@/components/SettlementClientMessage.vue";
import { mapGetters } from "vuex";

export default {
  name: "v-suggest-settlement",
  components: {
    SettlementWidget,
    SettlementClientMessage
  },
  props: ["label", "value", "rules", "errors", "isCourierShipment"],
  data() {
    return {
      loading: false,
      hideErrors: false,
      items: [],
      search: "",
      model: {},
      isAutoSelect: false
    }
  },

  watch: {
    search(val) {
      this.suggest(val);
    },
    value(val) {
      this.init();
    },
    errors(val) {
      this.hideErrors = false;
    }
  },

  computed: {
    searchText() {
      if (!!this.value && !!this.value.settlement && !!this.value.settlement.name)
        return "[" + this.value.country.code + "-" + this.value.post_code + "] " + this.value.settlement.name;

      return "";
    },
    errorMessages() {
      if (this.hideErrors)
        return null;
      return this.errors;
    },
    // Countries
    isNonBg() {
      return (this.value && this.value.country && this.value.country.code !== "BG");
    },
    ...mapGetters(['countriesVisible']),
    settlementClientMessage() {
      return !!this.model && !!this.model.settlement && !!this.model.settlement.client_message;
    },
    hint() {
      if (!this.model)
        return ' ';
      const settlementObj = this.model.settlement;
      if (!settlementObj)
        return ' ';
      const isCourier = this.isCourierShipment;
      const schedule = settlementObj.schedule;
      setTimeout(() => {
        postProcessMessageDOM(this, {
          servicing:    { courier: !!schedule ? schedule.small : null,   cargo: !!schedule ? schedule.large : null },
          isCourier
        });
      }, 200);
      return ' ';
    }
  },

  methods: {
    suggestImpl(val) {
      if (val) {
        if (this.model && this.model.text !== undefined && val !== this.model.text)
          this.querySelections(val);
      }
      else {
        this.model = { code: null, text: "" };
        this.items = new Array();
        this.changed();
      }
    },

    querySelections(q) {
      if (this.loading) {
        return;
      }
      this.loading = true;

      if (q === 'България') {
        q = '1000';
      }

      suggest.suggestSettlement({q}).then((result) => {
        if (this.isNonBg || this.isAutoSelect) {
          this.isAutoSelect = false;
          this.model = Object.assign(this.model, result.body.suggestions[0]);
          this.changed();
        }
        this.items = result.body.suggestions;
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.loading = false;
      });
    },

    init() {
      let text = this.searchText;
      if (!!text) {
        let//
        code = this.value.settlement.code;

        this.search = text;
        this.model = { code, text };
        this.model = Object.assign( this.model, this.value );
        this.items = new Array();
        this.items.push(this.model);
      } else {
        this.items = new Array();
      }
    },

    changed() {
      let// copy value
      s = JSON.parse(JSON.stringify( this.value ));

      if (this.model && this.model.code) {
        this.hideErrors = true;
        s.post_code = this.model.post_code;
        s.country = {
          "code" : this.model.country.code,
          "name" : this.model.country.name
        };
        s.settlement = {
          "code" : this.model.settlement.code,
          "name" : this.model.settlement.name,
          "schedule" : this.model.settlement.schedule,
          "client_message" : this.model.settlement.client_message,
          "delivery_days_courier" : this.model.settlement.delivery_days_courier,
          "delivery_days_cargo" : this.model.settlement.delivery_days_cargo
        };
      } else {
        this.hideErrors = false;
        s.post_code = "";
        s.country = {
          "code" : "BG",
          "name" : ""
        };
        s.settlement = {
          "code" : null,
          "name" : "",
          "schedule" : {
            "cargo" : [],
            "courier" : [],
            "small": {
              "type": "week_days",
              "week_days": []
            },
            "large": {
              "type": "week_days",
              "week_days": []
            }
          },
          "client_message" : "",
          "delivery_days_courier" : null,
          "delivery_days_cargo" : null
        };
      }
      this.$emit("input", s);
      if (this.model !== undefined)
        this.model.settlement = s.settlement;
    },

    dblclicked() {
      if (!this.isNonBg) {
        this.search = '?';
      }
    },

    onCountry(item) {
      this.isAutoSelect = true;
      this.search = item.text;
    }
  },

  created() {
    this.suggest = debounce(this.suggestImpl, 500);
  },

  mounted() {
    this.init();
  }
}
</script>

<style scoped>
.v-select >>> .v-messages__message {
  font-size: 11px;
}
</style>
